module.exports = __webpack_public_path__ + "static/media/colour-temp.9f50bcdc.jpeg";